import { Environment } from "@/services/Environment";
import Vue from "vue";
import VueCropper from "vue-cropper";
import VueI18n from "vue-i18n";
import { sync } from "vuex-router-sync";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import sentry from "./sentry";
import store from "./store";

const moment = require("moment");

Vue.config.productionTip = false;

import ImageDisplay from "@/components/displays/ImageDisplay";

Vue.use(VueCropper);
Vue.use(VueI18n);

import t_cz from "@/assets/locale/translations_cz.json";
import t_de from "@/assets/locale/translations_de.json";
import t_en from "@/assets/locale/translations_en.json";
import t_es from "@/assets/locale/translations_es.json";
import t_fr from "@/assets/locale/translations_fr.json";
import t_it from "@/assets/locale/translations_it.json";
import t_nl from "@/assets/locale/translations_nl.json";
import t_pt from "@/assets/locale/translations_pt.json";
import t_ru from "@/assets/locale/translations_ru.json";

sync(store, router);

const messages = {
  en: t_en,
  es: t_es,
  pt: t_pt,
  fr: t_fr,
  cz: t_cz,
  de: t_de,
  it: t_it,
  nl: t_nl,
  ru: t_ru,
};
const ASSETS_URL = Environment.get("VUE_APP_ASSETS_URL");

Vue.mixin({
  data() {
    return {
      searchesLimit: 20,
      fromRegistration: false,
      browserLang: this.getBrowserLang(),
    };
  },
  methods: {
    doNothing() {},
    logAcademyActivity(data) {
      if (data && data.activityType) {
        data["source"] = "tablet";
        data["managedAcademy"] = this.$store.state.tabletManagedAcademy;
        //Api().post("users/activity/" + data.activityType, data);
        console.log("Logging activity: ", data);
      }
    },
    isValidEmail(email) {
      let regex =
        /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    },
    isSmallerDisplay() {
      if (
        this.$vuetify.breakpoint.name == "xs" ||
        this.$vuetify.breakpoint.name == "sm"
      )
        return true;
      else return false;
    },
    seconds2Minutes(time) {
      if (!time) return "00:00";
      let minutes = Math.floor(time / 60);
      let seconds = time - minutes * 60;
      if (minutes < 10) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;
      return minutes + ":" + seconds;
    },
    isBirthday(date) {
      if (!date) return false;
      date = new Date(this.removeDateStringTimezone(date));
      const today = new Date();
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth()
      );
    },
    getStatusColor(t) {
      if (t) {
        if (!t._id) {
          if (t == "active") return "green";
          else if (t == "expired") return "red";
          else if (t == "pending_payment") return "#FFD700";
          else return "#FFD700";
        } else {
          if (t.cancelled) return "red";
          else if (t.completed) return "green";
          else return "#FFD700";
        }
      }
    },
    assets(file) {
      if (file) return ASSETS_URL + "/" + file;
      else return ASSETS_URL;
    },
    navigateTo(info) {
      this.$router.push(info);
    },
    truncateString(value, limit, skipDots) {
      if (value) {
        let dots = "...";
        if (skipDots) dots = "";
        if (!limit) {
          limit = this.descriptionLimit;
          dots = "";
        }
        if (value.length > limit) {
          value = value.substring(0, limit - 3) + dots;
        }
        return value;
      }
    },
    removeDateStringTimezone(str) {
      if (!str) return null;
      // Remove timezone info (.000Z or anything after seconds)
      const localDateStr = str.replace(/(\.\d{3}Z|Z)$/i, "");
      //Might contain timezone offsets like +00:00 or -04:00:
      const sanitizedDateStr = localDateStr.replace(/([+-]\d{2}:\d{2})$/, "");
      return sanitizedDateStr;
    },
    themeColor(color) {
      let theme = this.$store.state.theme;
      if (!theme) theme = "dark";
      let themeColor = this.$vuetify.theme.themes[theme][color];
      if (themeColor) return themeColor;
      else return this.$vuetify.theme.themes.light.primary;
    },
    setLang(lang) {
      if (!lang) {
        const browserLang = navigator.language;
        if (
          this.$store &&
          this.$store.state &&
          !this.$store.state.tabletLanguage
        ) {
          var newLang = "en";
          if (browserLang) {
            if (browserLang.indexOf("es") >= 0) newLang = "es";
            else if (browserLang.indexOf("fr") >= 0) newLang = "fr";
            else if (browserLang.indexOf("pt") >= 0) newLang = "pt";
          }
          this.$i18n.locale = newLang;
        }
      } else {
        this.$i18n.locale = lang;
      }
    },
    toNiceDateCustomFormatAdjusted(d, format) {
      return moment(d).format(format);
    },
    getBrowserLang() {
      var lang = "en";
      var blang = navigator.language || navigator.userLanguage;
      if (blang) {
        const split = blang.split("-");
        lang = split[0];
      }
      return lang;
    },
    getBeltColor(belt) {
      if (belt == "white") return "#FFFFFF";
      else if (belt == "blue") return "#1B75BC";
      else if (belt == "purple") return "#8D70B2";
      else if (belt == "brown") return "#A97942";
      else if (belt == "black") return "#000000";
      else if (belt == "red") return "#ED1C24";
      else return "#FFFFFF";
    },
    getColor(c) {
      var color = "white";
      if (c == "light") color = "grey";
      else if (c == "dark") color = "white";
      else if (c == "blue") color = "#1B75BC";
      else if (c == "purple") color = "#8D70B2";
      else if (c == "brown") color = "#A97942";
      else if (c == "black") color = "black";
      else if (c == "primary") color = "#1B75BC";
      else if (c == "bronze") color = "#cd7f32";
      else if (c == "gold") color = "#FFD700";
      else if (c == "silver") color = "#C0C0C0";
      else if (c == "red") color = "#EC7063";
      else if (c == "gray") color = "#f5f5f5";
      else if (c) color = c;
      return color; //#4b4b4b; gray
    },
    getDayString(day) {
      var weekdays = new Array(7);
      weekdays[0] = "sunday";
      weekdays[1] = "monday";
      weekdays[2] = "tuesday";
      weekdays[3] = "wednesday";
      weekdays[4] = "thursday";
      weekdays[5] = "friday";
      weekdays[6] = "saturday";
      return weekdays[day.getDay()];
    },
    userFile(path) {
      //Replace with versionn 2: return process.env.API_FILES_HOST + img;
      if (!path || path == "")
        return (
          Environment.get("VUE_APP_ASSETS_HOME") + "/default-profile-avatar.png"
        );
      else if (path.indexOf("https:") == 0) return path;
      else if (path.indexOf("userfiles") >= 0)
        return Environment.get("VUE_APP_API_HOST") + "/api/" + path;
      else return Environment.get("VUE_APP_API_HOST") + "/api/" + path;
    },
    getInitials(name) {
      if (!name) return "";
      const p = name.split(" ");
      return (p[0][0] + (p[1] ? p[1][0] : "")).toUpperCase();
    },
  },
});

const dateTimeFormats = {
  en: {
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    month_day_year: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    month_day: {
      month: "short",
      day: "numeric",
    },
    month_year: {
      month: "short",
      year: "numeric",
    },
    short: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
    clock: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
  },
  fr: {
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    month_day: {
      month: "short",
      day: "numeric",
    },
    month_year: {
      month: "long",
      year: "numeric",
    },
    month_day_year: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    short: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
    clock: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
  },
  es: {
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    month_day_year: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    month_day: {
      month: "short",
      day: "numeric",
    },
    month_year: {
      month: "long",
      year: "numeric",
    },
    short: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
    clock: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
  },
  pt: {
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    month_day_year: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    month_day: {
      month: "short",
      day: "numeric",
    },
    month_year: {
      month: "long",
      year: "numeric",
    },
    short: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
    clock: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
  },
};

Vue.component("ImageDisplay", ImageDisplay);

const i18n = new VueI18n({
  locale: "en", // set locale
  fallbackLocale: "en",
  messages, // set locale messages
  dateTimeFormats,
  silentTranslationWarn: true,
});

sentry(Vue);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
